import React from "react";

import { Button } from "~/components/button";
import { IconUser } from "~/components/icon";
import { SkeletonText } from "~/components/skeleton/text";

import { logout } from "../../backend/LoginApi";
import { useUserProfile } from "../../common/use-user-profile";
import { Popover } from "../../components/react/popover/Popover";

export interface AccountInfoProps {
	guiAuth: boolean;
}

export const AccountInfo: React.FC<AccountInfoProps> = React.memo(({ guiAuth }) => {
	const [userProfile] = useUserProfile();

	return (
		<Popover
			align={POPOVER_ALIGN}
			content={
				<div className="w-75 p-6.25">
					<div className="mb-5 px-1.25 text-center font-medium text-sm leading-normal">
						<div>You are currently logged in as</div>
						<SkeletonText
							className="text-black"
							el="strong"
							randomize
							when={userProfile?.displayName || userProfile?.name}
						/>
					</div>

					{guiAuth ? (
						<Button
							className="w-full uppercase"
							layout="block"
							onClick={() => logout()}
							type="submit"
							variant="primary"
						>
							Log out
						</Button>
					) : null}
				</div>
			}
		>
			<Button data-testid="account-info-menu-button" icon>
				<IconUser className="text-lg text-white" />
			</Button>
		</Popover>
	);
});

const POPOVER_ALIGN = {
	offset: [0, -10],
};
